// extracted by css-extract-rspack-plugin
export default {"tabsList":"g7WL7a","tabsTrigger":"nxgdOn","tabsContent":"U6NUg1"};